"use strict";
import "lodash";
import moment from "moment";
import { message } from "antd";

import { svc_search, svc_fetchOne, svc_editOne } from "@/services";
import logger from "@/utils/logger";
import { convertISODateTimeToString } from "@/utils/convertTime";
import { showServerResponse } from "@/utils/message";
import config from "@/../config/config.json";

const endpointBasePrefix = "settlements";

const Model = {
	namespace: "m_Settlement",
	state: {
		// settlements: [],
	},
	reducers: {
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			let settlements = yield call(svc_search, endpointBasePrefix, payload);

			_.forEach(settlements.result, function (row) {
				row.key = row.id;

				row = convertISODateTimeToString(row, ["accounting_date"], config.dateFormat);
				row = convertISODateTimeToString(row, ["start_time", "end_time"], config.dateTimeFormat);

				_.forEach(row.details, function (detail) {
					detail.key = detail.id;
					detail.float = detail.float.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
					detail.revenue = detail.revenue.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
					detail.collected = detail.collected.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
					detail.difference = detail.difference.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
				});
			});

			// yield put({
			// 	type: "handleFetchAll",
			// 	payload: { settlements },
			// });

			return settlements;
		},
		*editCollected({ payload }, { call }) {
			let response = yield call(svc_editOne, endpointBasePrefix, payload, "id");
			showServerResponse(response);
			return response;
		},
	},
	subscriptions: { },
};

export default Model;
